const POWER_ORBS = new Set(['power-orb', 'power-orb-2']);

export function canRerollRelic(collectable) {
  return collectable?.type === 'relic' && !POWER_ORBS.has(collectable.value?.key);
}
